/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActionType,
    ActionTypeFromJSON,
    ActionTypeFromJSONTyped,
    ActionTypeToJSON,
} from './ActionType';
import {
    ElementType,
    ElementTypeFromJSON,
    ElementTypeFromJSONTyped,
    ElementTypeToJSON,
} from './ElementType';
import {
    Status,
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ActionHistoryElementResponse
 */
export interface ActionHistoryElementResponse {
    /**
     * 
     * @type {string}
     * @memberof ActionHistoryElementResponse
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionHistoryElementResponse
     */
    userEmail: string | null;
    /**
     * 
     * @type {ActionType}
     * @memberof ActionHistoryElementResponse
     */
    action: ActionType;
    /**
     * 
     * @type {ElementType}
     * @memberof ActionHistoryElementResponse
     */
    element: ElementType;
    /**
     * 
     * @type {Status}
     * @memberof ActionHistoryElementResponse
     */
    status: Status;
    /**
     * 
     * @type {string}
     * @memberof ActionHistoryElementResponse
     */
    complementaryInformation: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ActionHistoryElementResponse
     */
    createdAt: Date | null;
}

export function ActionHistoryElementResponseFromJSON(json: any): ActionHistoryElementResponse {
    return ActionHistoryElementResponseFromJSONTyped(json, false);
}

export function ActionHistoryElementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionHistoryElementResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userEmail': json['userEmail'],
        'action': ActionTypeFromJSON(json['action']),
        'element': ElementTypeFromJSON(json['element']),
        'status': StatusFromJSON(json['status']),
        'complementaryInformation': json['complementaryInformation'],
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
    };
}

export function ActionHistoryElementResponseToJSON(value?: ActionHistoryElementResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userEmail': value.userEmail,
        'action': ActionTypeToJSON(value.action),
        'element': ElementTypeToJSON(value.element),
        'status': StatusToJSON(value.status),
        'complementaryInformation': value.complementaryInformation,
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
    };
}

